module.exports = __webpack_public_path__ + "static/img/touch.ba3be662.png";